import {Dropbox} from '@dropbox/api-v2-client';

export const getAPIForLoggedInUser = async (accessToken: string) =>
  new Dropbox({
    accessToken,
    clientId: 'ypinvt9stya656b',
  });
